// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__19URb","header":"ClearentDisclaimer_header__1-ZRZ","inner":"ClearentDisclaimer_inner__3hF1y"};